const ITEMS = [
  'Betim',
  'Contagem',
  'Belo Horizonte',
  'Transferência',
  'Licenciamento',
  'Emplacamento Mercosul',
  'Alvará de Liberação',
  'DETRAN-MG',
  'Consulta de Débitos',
  'Minas Gerais',
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-slate-200 bg-slate-50 py-5 overflow-hidden"
    >
      <div className="marquee-track items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display text-xl sm:text-2xl font-bold uppercase tracking-wide text-slate-300 whitespace-nowrap">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
